// extracted by mini-css-extract-plugin
export var clearButton = "AutocompleteCompanyField-module--clear-button--28eb5";
export var container = "AutocompleteCompanyField-module--container--20700";
export var inputLike = "AutocompleteCompanyField-module--input-like--903f4";
export var menuList = "AutocompleteCompanyField-module--menu-list--cc42e";